import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M14 8h-4v8h4","key":"svg-1"}],["path",{"d":"M10 12h2.5","key":"svg-2"}]]

const IconCircleLetterE = createReactComponent('outline', 'circle-letter-e', 'CircleLetterE', __iconNode);

export default IconCircleLetterE;